import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import Modal from '../../../../../core/components/Modal';
import { assignRefs, printToast } from '../../../../../core/utils/Global';
import BaseForm from '../../../../../core/page/components/baseForm/BaseForm';
import styles from './ModalJustificativaInativacao.module.scss';
import InputTypes from '../../../../../core/enums/InputTypes';
import InputField from '../../../../../components/inputField/InputField';
import { InputTextarea } from 'primereact/inputtextarea';
import InputTextLengthCounter from '../../../../../core/components/inputs/inputTextLengthCounter/InputTextLengthCounter';
import { Button } from 'primereact/button';
import tipoSolicitacaoAtivacaoService from '../../../../../service/TipoSolicitacaoAtivacaoService';
import solicitacaoAtivacaoIndicadorService from '../../../../../service/SolicitacaoAtivacaoIndicadorService';
import PageMessages from '../../../../../config/translations/PageMessages';
import Pages from '../../../../../config/Pages';
import { axiosErrorShow } from '../../../../../config/Axios';
import ConfirmDialog from '../../../../../core/components/ConfirmDialog';

const inputs = [
    {
        name: 'idProposta',
        label: 'ID Proposta',
        type: InputTypes.INTEGER,
        form: { use: true },
    },
    {
        name: 'justificativa',
        label: 'Justificativa',
        type: InputTypes.STRING,
        form: { use: true, initialValue: '', validate: { required: true, max: 500 } },
    },
];

const ModalHeader = forwardRef((props, ref) => {
    const [title, setTitle] = useState('');
    useImperativeHandle(ref, () => ({ setTitle }), []);
    return (
        <>
            <i className={`pi pi-stop-circle ${styles.iconHeader}`} />
            {title}
        </>
    );
});

function ModalJustificativaInativacao({ onSave, ...props }, ref) {
    const modalRef = useRef(null);
    const headerRef = useRef(null);
    const confirmRef = useRef(null);

    const Inputs = ({ formik, formController }) => (
        <form onSubmit={formik.handleSubmit} className={`p-col-12 p-grid p-fluid ${styles.form}`}>
            <InputField id="justificativa" formik={formik} formController={formController}>
                <InputTextLengthCounter maxLen={500}>
                    <InputTextarea
                        rows={5}
                        name="justificativa"
                        value={formik.values.justificativa}
                        onChange={formik.handleChange}
                    />
                </InputTextLengthCounter>
            </InputField>
            <div className="buttonsRight">
                <Button
                    label="Cancelar"
                    className="p-button-secondary"
                    type="button"
                    icon="pi pi-arrow-left"
                    onClick={() => modalRef.current?.hide()}
                />
                <Button
                    label={formik.values?.ativar ? 'Ativar' : 'Inativar'}
                    className="p-button-info"
                    type="submit"
                    icon="pi pi-check"
                    onClick={() => formController.addCountClick()}
                />
            </div>
        </form>
    );

    const ModalBody = ({ modalData }) => {
        const { idIndicador, ativar } = modalData;

        useEffect(() => {
            headerRef.current?.setTitle(ativar ? 'Ativar Indicador' : 'Inativar Indicador');
        }, [headerRef]);

        return (
            <>
                <ConfirmDialog isOk ref={confirmRef} />
                <BaseForm
                    showToast={false}
                    redirectOnSave={false}
                    buscarOnLoad={false}
                    actionOnSave={(dados) => {
                        if (onSave) {
                            onSave(dados);
                        }

                        if (dados?.success) {
                            printToast({
                                severity: 'success',
                                summary: Pages.sei.indicador.title,
                                detail: PageMessages.sei.indicador.successOnInactivate.replace(
                                    '{TIPO}',
                                    ativar ? 'Ativação' : 'Inativação'
                                ),
                            });
                        }
                    }}
                    onSubmit={async ({ registro }) => {
                        try {
                            const response = await solicitacaoAtivacaoIndicadorService.salvar(
                                registro
                            );
                            return response;
                        } catch (error) {
                            if (
                                `${error?.response?.data?.message}`.includes(
                                    PageMessages.sei.indicador.solicitacaoInativacao
                                        .partialMessages[0]
                                ) &&
                                `${error?.response?.data?.message}`.includes(
                                    PageMessages.sei.indicador.solicitacaoInativacao
                                        .partialMessages[1]
                                )
                            ) {
                                confirmRef.current?.show(error?.response?.data?.message);
                            } else {
                                axiosErrorShow(error);
                            }
                            throw new Error(error);
                        }
                    }}
                    initialValues={inputs.filter((input) => input?.form?.use ?? false)}
                    prepareInitialValues={async (data) => {
                        const tipos = await tipoSolicitacaoAtivacaoService.list();
                        return {
                            ...data,
                            ativar,
                            idIndicador,
                            tipos,
                        };
                    }}
                >
                    <Inputs />
                </BaseForm>
            </>
        );
    };

    return (
        <Modal
            header={<ModalHeader ref={headerRef} />}
            style={{ maxWidth: '60vw' }}
            widthOnMobile={700}
            onMobile={(styles) => ({ ...styles, maxWidth: '100vw', height: '100%' })}
            ref={assignRefs(ref, modalRef)}
            {...props}
        >
            <ModalBody />
        </Modal>
    );
}

export default forwardRef(ModalJustificativaInativacao);
